module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/icon_close-ead53d3d89de93aa0dcccc8e2acfb17e.png";